export const HOME_PAGE = '/';
export const AUTH_PAGE = '/auth';
export const CATALOG_DIAMONDS_COLORLESS_PAGE = '/catalog/diamond-colorless';
export const CATALOG_DIAMONDS_COLORLESS_EDIT_PAGE = `${CATALOG_DIAMONDS_COLORLESS_PAGE}/edit`;
export const CATALOG_DIAMONDS_FANCY_PAGE = '/catalog/diamond-fancy';
export const CATALOG_DIAMONDS_FANCY_EDIT_PAGE = `${CATALOG_DIAMONDS_FANCY_PAGE}/edit`;
export const CATALOG_ROUGH_PAGE = '/catalog/rough';
export const CATALOG_ROUGH_EDIT_PAGE = `${CATALOG_ROUGH_PAGE}/edit`;
export const CATALOG_JEWELRY_PAGE = '/catalog/jewelry';
export const CATALOG_JEWELRY_EDIT_PAGE = `${CATALOG_JEWELRY_PAGE}/edit`;
export const CATALOG_LGD_COLORLESS_PAGE = '/catalog/lgd-colorless';
export const CATALOG_LGD_COLORLESS_EDIT_PAGE = `${CATALOG_LGD_COLORLESS_PAGE}/edit`;
export const CATALOG_LGD_FANCY_PAGE = '/catalog/lgd-fancy';
export const CATALOG_LGD_FANCY_EDIT_PAGE = `${CATALOG_LGD_FANCY_PAGE}/edit`;
export const CATALOG_LGD_ROUGH_PAGE = '/catalog/lgd-rough';
export const CATALOG_LGD_ROUGH_EDIT_PAGE = `${CATALOG_LGD_ROUGH_PAGE}/edit`;
export const COLLECTIONS_PAGE = '/collections';
export const PRESENTATION_COLLECTIONS_PAGE = '/IGC2023';
export const SINGLE_COLLECTION_PAGE = '/~:collectionId';
export const SINGLE_COLLECTION_EDIT_PAGE = '/~:collectionId/edit';
export const SINGLE_COLLECTION_PAIR_SORTING_PAGE = '/~:collectionId/pair-sorting';
export const SURVEY_PAGE = '/survey';
export const PROJECTS_PAGE = '/projects';
export const SHARED_WITH_ME_PROJECTS_PAGE = '/shared-with-me-projects';
export const CARBON_VIEWER_PAGE = '/carbon-viewer';
export const OLD_GRADING_REDIRECT_PAGE = '/grading/custom/color-1?id[]=49192&id[]=49193&id[]=48791&id[]=48794&id[]=48820&id[]=48793&id[]=48821&sp=75';
